import Constants from "utils/Constants";
import { useState, useEffect, useCallback } from "react";
import DateInput from "./DateInput";
import TimeInput from "./TimeInput";
import DateTimeInput from "./DateTimeInput";
import dayjs from "dayjs";

const DateTime = ({
  field,
  existingValue,
  onChange,
  inputSize,
  type,
  disabled = false,
  setIsOpen = null,
  isRecord = false,
}) => {
  const [value, setValue] = useState(undefined);

  const updateValue = useCallback(() => {
    let type = field?.FieldType;
    let val = null;

    if (existingValue && type === Constants.FIELDTYPES.DATE) {
      val = dayjs(existingValue);
      val.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    } else if (existingValue && type === Constants.FIELDTYPES.DATE_TIME) {
      val = dayjs(existingValue);
    } else if (existingValue && type === Constants.FIELDTYPES.TIME) {
      val = dayjs(existingValue, "HH:mmZZ");
    }

    setValue(val || "");
  }, [existingValue, field?.FieldType]);

  const handleValueChange = (mom) => {
    setValue(mom);

    if (onChange && typeof onChange == "function") {
      onChange(mom);
    }
  };

  useEffect(() => {
    updateValue();
  }, [updateValue]);

  return (
    <>
      {type === Constants.FIELDTYPES.DATE && (
        <DateInput
          isRecord={isRecord}
          inputSize={inputSize}
          field={field}
          onChange={handleValueChange}
          value={value}
          disabled={disabled}
          setIsOpen={setIsOpen}
        />
      )}
      {type === Constants.FIELDTYPES.TIME && (
        <TimeInput
          isRecord={isRecord}
          inputSize={inputSize}
          field={field}
          onChange={handleValueChange}
          value={value}
          disabled={disabled}
          setIsOpen={setIsOpen}
        />
      )}
      {type === Constants.FIELDTYPES.DATE_TIME && (
        <DateTimeInput
          isRecord={isRecord}
          inputSize={inputSize}
          field={field}
          onChange={handleValueChange}
          value={value}
          disabled={disabled}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
};

export default DateTime;
